import L from 'leaflet';

const { themeData = {} } = window;

export default {
  init() {
    this.initMap();
  },

  initMap() {
    const mapElement = document.getElementById("map");
    if (mapElement) {
      if (mapElement._leaflet_id) return;

      mapElement.style.height = "360px";
      const centerCoordinates = [50.25472322665085, 19.061661653678286];
      const map = L.map(mapElement).setView(centerCoordinates, 15);

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map);

      const customIcon = L.icon({
        iconUrl: themeData.logo || "",
        iconSize: [50, 50],
        iconAnchor: [25, 50],
        popupAnchor: [0, -50],
      });

      L.marker(centerCoordinates, { icon: customIcon })
        .addTo(map)
        .bindPopup('<span style="font-size:13px"><b>Pegaz Kominki</b>')
        .openPopup();
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateContact.js